$(document).ready(function() {
  $('br').attr('aria-hidden','true');
  $('hr').attr('aria-hidden','true');
  

});

$(document).ready(function() {
  $('a#back-to-top').on('click', function(e) {
    e.preventDefault();
    setTimeout(() => {
    $('#back-btn').focus();      
    }, 500);
  });
});

// empty Headings
$(document).ready(function() {
  $('h1, h2, h3, h4, h5, h6').filter(function() {
    return $(this).text().replace(/\s+/g, '') === '' && 
           $(this).children().length === 0;
  }).remove();
});

// Social and External link warning Fixed
$(document).ready(function() {
  const currentHost = window.location.hostname.replace('www.', '');
  const warningText = " (this link will open in new tab)";

  $('a[href^="http://"], a[href^="https://"]').each(function() {
    const $link = $(this);
    const linkHost = this.hostname.replace('www.', '');

    if (linkHost === currentHost || !linkHost) return; // Skip internal links

    // Get text or fallback from image alt
    let linkText = $link.text().trim();
    if (!linkText) {
      const imgAlt = $link.find('img').attr('alt');
      linkText = imgAlt ? imgAlt.trim() : "this link";
    }

    // Build aria-label
    const currentAriaLabel = $link.attr('aria-label');
    const newLabel = currentAriaLabel 
      ? `${currentAriaLabel}${warningText}` 
      : `${linkText}${warningText}`;

    // Apply attributes
    $link.attr({
      'aria-label': newLabel,
      'title': newLabel, // optional
      'target': '_blank',
      'rel': 'noopener noreferrer nofollow'
    });

    // Add external-link class for styling
    $link.addClass('external-link');
  });
});

// Email Label to all Email Address
$(document).ready(function() {
  // Target ALL email links (any format)
  $('a[href^="mailto:"]').each(function() {
    // Extract email from href
    let email = $(this).attr('href').replace('mailto:', '').trim();
    
    // Clean email (remove query parameters, URL-encoded spaces, etc.)
    email = decodeURIComponent(email) // Handle %20, %40, etc.
            .split('?')[0]           // Remove ?subject=...
            .split('&')[0];           // Remove &body=...
    
    // Set aria-label
    $(this).attr('aria-label', 'Email Address: ' + email);
  });
});

// Phone Label to all Phone Number
$(document).ready(function() {
  $('a[href^="tel:"]').each(function() {
    const $link = $(this);
    const visibleText = $link.text().trim(); // Get what's visually shown
    const existingLabel = $link.attr('aria-label') || '';

    // Only add if not already present
    if (!existingLabel.includes('Phone Number')) {
      const newLabel = `Phone Number: ${visibleText}` + (existingLabel ? `, ${existingLabel}` : '');
      $link.attr('aria-label', newLabel);
    }
  }); 
}); 

// // Quick Buy Card
$(document).ready(function () {
  const gridSelector = '.product-grid.product-grid--per-row-4.product-grid--per-row-mob-2.slider__grid.product-grid--carousel';
 
  // store original alts (only if not already stored)
  function storeOriginalAlts() {
    $(`${gridSelector} img`).each(function () {
      const $img = $(this);
      if (typeof $img.attr('data-original-alt') === 'undefined') {
        $img.attr('data-original-alt', $img.attr('alt') || '');
      }
    });
  }
 
  // make only the active images accessible across all sliders
  function setOnlyActiveAccessible() {
    // hide all and blank alt
    $(`${gridSelector} .img-ar.img-ar--contain`).attr('aria-hidden', 'true')
      .find('img').attr('alt', '');
 
    // for each active slide inside each slider grid
    $(`${gridSelector} .product-block__image--active`).each(function () {
      $(this).find('.img-ar.img-ar--contain')
        .attr('aria-hidden', 'false')
        .find('img').each(function () {
          const $img = $(this);
          const orig = $img.attr('data-original-alt') || '';
          $img.attr('alt', orig);
        });
    });
  }
 
  // initial store + run
  storeOriginalAlts();
  setOnlyActiveAccessible();
 
  // observe the whole section (all grids inside)
  const containers = document.querySelectorAll(gridSelector);
  containers.forEach(container => {
    const observer = new MutationObserver(function () {
      storeOriginalAlts();
      setOnlyActiveAccessible();
    });
    observer.observe(container, { attributes: true, childList: true, subtree: true, attributeFilter: ['class', 'style'] });
  });
 
  // also update on interactions globally
  $(document).on('click keydown focusin touchstart', function () {
    storeOriginalAlts();
    setOnlyActiveAccessible();
  });
});

// quickbuy focus jump to close btn
$(document).ready(function () {
  $(document).on('click', '.quickbuy-toggle', function (e) {
    e.preventDefault(); 
    
    setTimeout(function () {
      $('.close-detail').focus();
    }, 1300);
  });
}); 

// Main Menu
$(document).ready(function () {
  // 1. Disable theme’s hover behaviour
  $('.desktop-only .navigation__item--with-children')
    .off('mouseenter mouseleave') // remove JS hover bindings
    .removeClass('navigation__item--show-children'); // reset hover classes

  // 2. Click-to-toggle dropdowns
  $('.desktop-only .navigation__tier-1 > .navigation__item--with-children > .navigation__link').on('click', function (e) {
    e.preventDefault();
    var parentItem = $(this).parent();

    // Close other open menus
    $('.desktop-only .navigation__item--with-children.navigation__item--show-children')
      .not(parentItem)
      .removeClass('navigation__item--show-children')
      .children('.navigation__link')
      .attr('aria-expanded', 'false');

    // Toggle the clicked one
    if (parentItem.hasClass('navigation__item--show-children')) {
      parentItem.removeClass('navigation__item--show-children');
      $(this).attr('aria-expanded', 'false').focus();
    } else {
      parentItem.addClass('navigation__item--show-children');
      $(this).attr('aria-expanded', 'true').focus();
    }
  });

  // 3. Close menu when clicking outside
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.desktop-only .navigation__item--with-children').length) {
      $('.navigation__item--with-children.navigation__item--show-children')
        .removeClass('navigation__item--show-children')
        .children('.navigation__link')
        .attr('aria-expanded', 'false');
    }
  });

  // 4. Close menu on ESC key and return focus
  $(document).on('keydown', function (e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      var openMenu = $('.desktop-only .navigation__item--with-children.navigation__item--show-children');
      if (openMenu.length) {
        var parentLink = openMenu.children('.navigation__link');
        openMenu.removeClass('navigation__item--show-children');
        parentLink.attr('aria-expanded', 'false').focus();
      }
    }
  });
});


// Collection Page quickbuy button focus
$(document).on("click", ".quickbuy-toggle", function() {
  var $productBlock = $(this).closest("product-block");
  setTimeout(function() {
    var $closeBtn = $productBlock.find(".close-detail");
    if ($closeBtn.length) {
      $closeBtn.focus();
    }
  }, 1500);
});

// Search Focus Return
$(document).on("click", ".main-search__close", function () {
  $("body").removeClass("show-search");   // hide search
  $(".show-search-link").focus();         // return focus
});

// Close search with ESC key and return focus
$(document).on("keydown", function (e) {
  if (e.key === "Escape" || e.keyCode === 27) {
    if ($("body").hasClass("show-search")) { // check if search is open
      $("body").removeClass("show-search");  // close search
      $(".show-search-link").focus();        // return focus to trigger
    }
  }
});

// mobile Menu
$(document).ready(function () {
  // When user clicks the "Open Menu" button
  $(document).on("click", 'button.mobile-nav-toggle[aria-label="Open Menu"]', function (e) {
    e.preventDefault();
    setTimeout(function () {
      $('.navigation.navigation--main').attr('tabindex', '-1').focus();
    }, 300); // 1 second delay
  }); 

  // When user clicks the "Close Menu" button
  $(document).on("click", 'a.mobile-nav-toggle[aria-label="Close Menu"]', function (e) {
    e.preventDefault();
    setTimeout(function () {
      $('button.mobile-nav-toggle[aria-label="Open Menu"]').focus();
    }, 300); // 1 second delay
  });
}); 

// Product Page tab
$(".komuello-tabs .tab-header").each(function() {
    var headingTitle = $(this).text().trim();
    $(this).attr("aria-label", headingTitle);
});
 
$(".komuello-tabs .tab-header").attr({
    'aria-expanded': 'false',
    'role': 'button',
    'tabindex': 0
});
 
$(".komuello-tabs .tab-header").click(function (e) {
    e.preventDefault();
    $(this).attr('aria-expanded', function (i, attr) {
        return attr == 'true' ? 'false' : 'true';
    });
});

// 
$(document).ready(function() {
  if ($(window).width() <= 767) {
    $('.icon-chevron').hide();
  }

  let lastFocusedBtn = null;
 
$(".mobile-navigation-drawer .navigation__item--with-children .navigation__link").on("click", function () {
  lastFocusedBtn = $(this);
 
  const targetId = $(this).attr("aria-controls");
  const $submenu = $("#" + targetId);
 
  setTimeout(function () {
    $submenu.attr("tabindex", 0).focus();
  }, 1000);
});
 
$("[id^='NavigationTier2-'][id$='-mobMobileNav'] #close-submenuMobileNav").on("click", function () {
  setTimeout(function () {
    if (lastFocusedBtn) {
      lastFocusedBtn.attr("tabindex", 0).focus();
    }
  }, 1000);
});
$(".desktop-only .navigation--main .navigation__tier-1 .navigation__item--with-children > a.navigation__link").attr("aria-expanded","false").attr("role","button");

// $('.mobile-only.toggle-btn--revealed-desktop').on('click', function(e) {
//     e.preventDefault();
//     setTimeout(() => {
//     $('.filters__close').focus();      
//     }, 500);
//   });
// $('.filters__close').on('click', function(e) {
//     e.preventDefault();
//     setTimeout(() => {
//     $('.mobile-only.toggle-btn--revealed-desktop').focus();      
//     }, 500);
//   });
var lastFocusedButton;
$(".mobile-only.toggle-btn--revealed-desktop").on("click", function () {
  lastFocusedButton = $(this);
  setTimeout(function () {
    $(".filters__close").attr("tabindex", 0).focus();
  }, 1000);
});
$(".filters__close").on("click", function () {
  setTimeout(function () {
    if (lastFocusedButton) {
      lastFocusedButton.attr("tabindex", 0).focus();
    }
  }, 1000);
});
});
